export default __webpack_public_path__ + "static/media/craftener-logo.dda910dc.png";